//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from "../other/Button";
import PatronAvatar from "./PatronAvatar";
export default {
  components: {
    Button,
    PatronAvatar
  },
  props: {
    myProfileData: {
      type: Object,
      default: () => {}
    },
    masterpieceId: {
      type: [String, Number],
      default: ''
    },
    masterpiece: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      email: '',
      anonymous: this.masterpiece?.patron?.anonymous || false,
      formError: null
    }
  },
  computed: {
    getAnonymous() {
      return this.masterpiece?.patron?.anonymous || false
    }
  },
  methods: {
    setAnonymous() {
      const defaultAnonymous =
      this.$axios({
        method: 'get',
        url: `/api/v1/patronage/setAnonymous?lang=${this.$i18n.locale || 'ru'}&anonymous=${this.anonymous}&masterpieceId=${this.masterpieceId}`,
      })
      .then(({data}) => {
        if(data.error) {
          this.formError = data.error.message
        } else {
          this.$router.push('/profile/gallery#patronat')
        }
      })
      .catch(err => {
        console.log('ошибка при загрузке данных', err)
      })
    },
    share(name) {
      let url
      const picture = this.masterpiece?.picture
      const title = 'Теперь я патрон шедевра!'
      const description = 'Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!'
      const image = (picture && picture.length) ? picture[0] : ''
      const shortUrl = `${window.location.origin || 'https://my.tretyakov.ru'}/app/collection/${this.myProfileData.id}`

      switch(name) {
        case 'vk':
          url = `https://vk.com/share.php?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&image=${image}`
          }
          break
        case 'ok':
          url = `https://connect.ok.ru/offer?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&imageUrl=${image}`
          }
          break
        default:
          return
      }
      this.popup(url)
    },
    popup (url) {
      const social_window = window.open(url, "share_window", `height=500,width=800,top=${window.innerHeight / 2 - 250},left=${window.innerWidth / 2 - 400}`);
      social_window.focus();
    }
  },
  head() {
    const masterpiece = this.masterpiece || {}
    //const author = masterpiece.author && masterpiece.author[0] ? masterpiece.author[0].name : ''
    return {
      // title: `Я открыл шедевр - ${author || '' }, ${masterpiece.name}`,
      title: 'Теперь я патрон шедевра!',
      meta: [
        { hid: 'og:title', property: 'og:title', content: 'Моя Третьяковка' },
        // { hid: 'title', property: 'og:title', content: `Я открыл шедевр - ${author || '' }, ${masterpiece.name}` },
        { hid: 'og:description', property: 'og:description', content: 'Стань патроном произведения и открой его для всего мира с Государственной Третьяковской галереей!' },
        { hid: 'og:url', property: 'og:url', content: `my.tretyakov.ru/app/collection/${this.myProfileData.id}?patronMasterpiece=${masterpiece.name}` },
      ]
    }
  }
}
